import { useEffect, useState } from "react";

// Shared Kids Corner sound setting (persisted). Videos and Lumi audio read this before playing sound.
const KEY = "kids_sound";
const EVENT = "kids-sound-change";

export const getKidsSoundOn = () => localStorage.getItem(KEY) !== "off";

export const setKidsSoundOn = (on) => {
  localStorage.setItem(KEY, on ? "on" : "off");
  window.dispatchEvent(new Event(EVENT));
};

export const useKidsSound = () => {
  const [on, setOn] = useState(getKidsSoundOn);
  useEffect(() => {
    const sync = () => setOn(getKidsSoundOn());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  return [on, (v) => setKidsSoundOn(typeof v === "boolean" ? v : !on)];
};
